import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

import { urlRetornoErp, temUrlErp } from "../../helpers/urlRetornoCrm";

// Casca visual das telas de acesso negado (usuário desativado, fora do horário, sessão
// encerrada). Existe para as três serem a mesma tela com texto diferente — antes cada
// motivo teria o seu card e elas iam divergindo.
//
// O botão "Acessar pelo ERP" só aparece quando se conhece a raiz do ERP do usuário (ver
// helpers/urlRetornoCrm): sem ela o destino seria "/index.xhtml" solto, que o navegador
// resolve no próprio Whaticket.
const useStyles = makeStyles((theme) => ({
	root: {
		position: "fixed",
		inset: 0,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		padding: theme.spacing(2),
		backgroundColor: theme.palette.background.default,
	},
	card: {
		maxWidth: 480,
		width: "100%",
		padding: theme.spacing(4),
		textAlign: "center",
	},
	icone: {
		fontSize: 64,
		marginBottom: theme.spacing(1),
	},
	titulo: {
		marginBottom: theme.spacing(1),
		fontWeight: 600,
	},
	mensagem: {
		color: theme.palette.text.secondary,
		marginBottom: theme.spacing(3),
	},
	detalhe: {
		color: theme.palette.text.secondary,
		fontSize: 12,
		marginBottom: theme.spacing(2),
	},
	acoes: {
		display: "flex",
		gap: theme.spacing(1),
		justifyContent: "center",
		flexWrap: "wrap",
	},
}));

const AvisoAcesso = ({ icone, corIcone, titulo, mensagem, detalhe, acoes }) => {
	const classes = useStyles();
	const mostrarBotaoErp = temUrlErp();

	return (
		<div className={classes.root}>
			<Paper className={classes.card} elevation={3}>
				{icone &&
					React.cloneElement(icone, {
						className: classes.icone,
						style: { ...(icone.props.style || {}), color: corIcone },
					})}

				<Typography variant="h6" className={classes.titulo}>
					{titulo}
				</Typography>

				<Typography variant="body2" className={classes.mensagem}>
					{mensagem}
				</Typography>

				{detalhe && <div className={classes.detalhe}>{detalhe}</div>}

				<div className={classes.acoes}>
					{mostrarBotaoErp && (
						<Button
							variant="contained"
							color="primary"
							onClick={() => window.location.assign(urlRetornoErp())}
						>
							Acessar pelo ERP
						</Button>
					)}
					{acoes}
				</div>
			</Paper>
		</div>
	);
};

export default AvisoAcesso;
